import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import * as fileApi from '../../../lib/api/file';
import * as projectApi from '../../../lib/api/project';

import {
  initOrder,
  unloadOrderAdd,
} from '../../../modules/projectModule/orderAdd';
import { listOrderLetters } from '../../../modules/projectModule/orderLetters';

import OrderBookModal from '../../../components/chancemng/obtainorder/OrderBookModal';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { chanceOrderCount } from '../../../modules/chanceModule/chance';

const OrderBookAddModalContainer = ({ type, open, handleClose }) => {
  const [isAuth, setIsAuth] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [apprUuid, setApprUuid] = useState(null);
  const scollToRef = useRef();

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);

  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };

  const { user, chance, receiveOrderInf, billInfList } = useSelector(
    ({ auth, chanceModule, projectModule, loading }) => ({
      chance: chanceModule.chance.chance,
      user: auth.user,
      receiveOrderInf: projectModule.orderAdd.receiveOrderInf,
      billInfList: projectModule.orderAdd.billInfList,
      loading: loading['orderAdd/INIT_ORDER'],
    }),
  );

  useEffect(() => {
    //최초 등록시 초기 데이터 생성함.
    if (chance) {
      dispatch(initOrder(chance));
      formik.setFieldValue('siDt', chance.expDay);
      formik.setFieldValue('comment', chance.forcastTxt);
      formik.setFieldValue('roProfitAmt', chance.totalProfit);
      formik.setFieldValue('roAdjProfitAmt', chance.totalProfit);
      formik.setFieldValue(
        'roProfitAmtPercent',
        getPercentByTotal(chance.totalProfit),
      );
      formik.setFieldValue(
        'roAdjProfitAmtPercent',
        getPercentByTotal(chance.totalProfit),
      );
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadOrderAdd());
    };
  }, [open]);

  const getPercentByTotal = (newValue) => {
    const totalSales = chance?.totalSales; //매출액
    const numberValue = Number(newValue);
    const percent = Math.round((numberValue / totalSales) * 100);
    return percent;
  };

  useEffect(() => {
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'MINUS_PO' && auth?.authYn === 'Y',
    );
    // console.log(findIndex, 'findIndex');
    if (findIndex !== -1) {
      setIsAuth(true);
    }
  }, [user]);

  const now = new Date();
  const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1); // 현재 월 1일
  const lastDayOfNextYear = new Date(now.getFullYear() + 1, 11, 31); // 내년 12월 31일

  const [initialValues, setInitialValues] = useState({
    mtnFreeTm: '',
    expDay: new Date(),
    siDt: '',
    mtnFreeStrtDt: firstDayOfCurrentMonth,
    mtnFreeEndDt: lastDayOfNextYear, 
    collCondt: '세금계산서 발행후 익월말',
    payCondt: '현금',
    comment: '',
    roProfitAmt: '', //매출이익
    roProfitAmtPercent: '', //매출액 대비 매출이익 퍼센트
    roCostAmt: 0, //영업비용
    roCostAmtPercent: 0, //매출액 대비 영업비용 퍼센트
    roAdjProfitAmt: 0, //최종 매출이익
    roAdjProfitAmtPercent: 0, //매출액 대비 최종 매출이익

    roInternalCosts: [
      {
        roPartnerUsrNm: '',
        roPartnerUsr: '',
        roInternalAmt: 0,
        roInternalAmtPercent: 0,
      },
    ],
    files: [{ fileDesc: '', file: null }],
  });

  const validationSchema = yup.object({
    expDay: yup
      .date('계약일을 입력하세요')
      .required('계약일을 입력하세요')
      .nullable()
      .default(undefined),
    siDt: yup
      .date('계약완료일을 입력하세요')
      .required('계약완료일을 입력하세요')
      .nullable()
      .default(undefined),
    mtnFreeStrtDt: yup
      .date()
      .test(
        'project-mtnFreeStrtDt',
        '무상 유지보수 시작일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .default(undefined),
    mtnFreeEndDt: yup
      .date()
      .test(
        'project-mtnFreeEndDt',
        '무상 유지보수 종료일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .min(yup.ref('mtnFreeStrtDt'), '무상유지보수 종료일을 확인하세요')
      .default(undefined),
    collCondt: yup.string().nullable(),
    payCondt: yup.string().nullable(),
    comment: yup.string().nullable(),

    /*
    roProfitAmt: yup
      .number()
      .test('roProfitAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
    roCostAmt: yup
      .number()
      .test('roCostAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
*/
    // 사용자 권한(MINUS_PO)이 있다면 min 적용 안함. 권한 없으면 min 적용

    roInternalCosts: yup.array().of(
      yup.object().shape({
        roPartnerUsrNm: yup
          .string('')
          .when('roInternalAmt', (roInternalAmt, schema) => {
            if (roInternalAmt)
              return schema.required('협업담당자를 입력하세요');
          }),
        roInternalAmt: yup
          .number()
          .test('roInternalAmt-min', '최소 0이상 입력하세요', function (value) {
            const result = !isAuth && value < 0 ? false : true;
            return result;
          }),
      }),
    ),
    
  });
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      if (!apprUuid || apprUuid === 'undefined') {
        setMessage('결재선이 선택되지 않았습니다. 결재선을 선택하세요');
        setVisible(true);
        return;
      }

      //console.log(dataToSubmit, 'dataToSubmit');

      onAddOrder(formik.values);

      onClose();
      setSubmitting(false);
    },
  });
  
  //valid 가 맞지 않을 때 스크롤.
  useEffect(() => {
    if (!formik?.isValid) {
      scollToRef.current?.scrollIntoView();
    }
  }, [formik?.isValid]);

  const onFileSave = async (value, orderInfo) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'PROJECT_PO');
    formData.append('fileAttrVal1', orderInfo.prjUuid);
    formData.append('fileAttrVal2', '수주품의서');
    formData.append('fileAttrVal3', orderInfo.roUuid);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar('수주품의서 파일 업로드 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onAddOrder = async (values) => {
    const orderLetterInfo = getReceiveOrderInf(formik.values);
    let dataToSubmit = {
      receiveOrderInf: orderLetterInfo,
      billInfList: billInfList,
      apprUuid: apprUuid,
    };

    try {
      const res = await projectApi.addReceiveOrder(dataToSubmit);

      if (res.data) {
        //실제 업로드 파일이 있다면
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach((value) => {
            onFileSave(value, res.data.receiveOrderInf);
          });
        }

        dispatch(listOrderLetters(chance.prjUuid));
        dispatch(chanceOrderCount(chance.prjUuid));

        enqueueSnackbar(`수주품의서 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  function getReceiveOrderInf(values) {
    // const dateDif = dayjs(values.mtnFreeEndDt) - dayjs(values.mtnFreeStrtDt);
    // const cDay = 24 * 60 * 60 * 1000;
    // const cMonth = cDay * 30; // 월 만듬
    // const difMonth = Math.ceil(dateDif / cMonth);

    let ReceiveOrderInf = {
      roUuid: receiveOrderInf.roUuid,
      prjUuid: receiveOrderInf.prjUuid,
      partnerUuid: receiveOrderInf.partnerUuid,
      employeeUuid: receiveOrderInf.employeeUuid,
      partnerInc: receiveOrderInf.partnerInc,
      chargeNm: receiveOrderInf.chargeNm,
      salesUuid: receiveOrderInf.salesUuid,
      collCondt: values.collCondt,
      payCondt: values.payCondt,
      comment: values.comment,
      // mtnFreeTm: difMonth,=> api 에서 계산
      expDay: values.expDay ? dayjs(values.expDay).format('YYYY-MM-DD') : null,
      siDt: values.siDt ? dayjs(values.siDt).format('YYYY-MM-DD') : null,
      mtnFreeStrtDt: values.mtnFreeStrtDt
        ? dayjs(values.mtnFreeStrtDt).format('YYYY-MM-DD')
        : null,
      mtnFreeEndDt: values.mtnFreeEndDt
        ? dayjs(values.mtnFreeEndDt).format('YYYY-MM-DD')
        : null,

      roProfitAmt: values.roProfitAmt, //매출이익
      roProfitAmtPercent: values.roProfitAmtPercent, //매출이익 퍼센트
      roCostAmt: values.roCostAmt,
      roCostAmtPercent: values.roCostAmtPercent,
      roAdjProfitAmt: values.roAdjProfitAmt,
      roAdjProfitAmtPercent: values.roAdjProfitAmtPercent,
      roTotalAmt: chance.totalSales, //총 매출액

      roInternalCosts: values.roInternalCosts, //내부거래비용array
    };
    return ReceiveOrderInf;
  }

  return (
    <>
      <OrderBookModal
        chance={chance}
        type={type}
        open={open}
        handleClose={onClose}
        orderInfo={receiveOrderInf}
        formik={formik}
        user={user}
        apprUuid={apprUuid}
        setApprUuid={setApprUuid}
        scollToRef={scollToRef}
      />
      <AskDialog
        visible={visible}
        title="확인"
        description={message}
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default OrderBookAddModalContainer;
